import { useCallback, useEffect, useState } from "react";

const useMountEffect = (mountFunction: () => Promise<void> | void) => {
  const [isMount, setIsMount] = useState(false);

  useEffect(() => {
    if (!isMount) setIsMount(true);
  }, [isMount]);

  const handleMountFunction = useCallback(async () => {
    await mountFunction();
  }, [mountFunction]);

  useEffect(() => {
    if (isMount) handleMountFunction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMount]);
};

export default useMountEffect;
